<template>
  <div class="copymove-box">
    <progressBar
      v-if="showProgress"
      :progress-data="progressData"
      @changeProgressStatus="changeProgressStatus"
    />
    <el-input
      v-if="haveSort"
      v-model="searchData"
      v-ie-placeholder
      :placeholder="canSort ? $t('搜索文件夹') : $t('暂不支持搜索')"
      class="copymove-search"
      :disabled="!canSort"
    >
      <span
        v-show="searchData"
        slot="suffix"
        class="search-clear"
      >
        <span
          v-show="isSearchLoading"
          class="icon-loading"
        >
          <img
            src="~image/search-load.gif"
            alt=""
          >
        </span>
        <span
          class="icon el-icon-circle-close"
          @click="clearAll"
        />
      </span>
    </el-input>
    <div
      v-else
      class="copymove-nosearch"
    />
    <div
      v-show="crumbData.length < 2"
      class="crumb-title"
    >
      <span>{{ $t('所有目录') }}</span>
    </div>
    <div
      class="copymove-content"
      :class="{'content-havesort':haveSort}"
    >
      <div
        v-show="crumbData.length > 1"
        class="copymove-crumb"
      >
        <crumb
          :crumb-data="crumbData"
          :crumb-title="searchTitle"
          @crumbJump="crumbJump"
        />
      </div>
      <div
        v-if="listData.length > 0 || showCreateFolder"
        id="copymove-scroll-list"
        class="copymove-list"
        :class="{'copymove-list-havesort':haveSort}"
        @scroll="loadMore($event)"
      >
        <!-- 新建文件夹部分开始 -->
        <div
          v-if="showCreateFolder"
          ref="newLine"
          class="new-folder"
          @click.stop=""
        >
          <svg class="icon file-icon">
            <use xlink:href="#folder" />
          </svg>
          <input
            ref="createFile"
            v-model="createData.filename"
            class="creat-file"
            type="text"
            @keyup.enter="createFolder"
          >
          <span class="wrap-btns">
          <span class="cancel">
               <svg
                 class="icon icon-cancel"
                 @click="cancelCreate"
               ><use xlink:href="#close" /></svg>
            </span>
            <span class="sure">
              <svg
                class="icon icon-sure"
                @click="createFolder"
              ><use xlink:href="#sure" /></svg>
            </span>
          </span>
        </div>
        <!-- 新建文件夹部分结束 -->
        <div
          v-for="item in listData"
          :key="item.neid"
          class="list-item"
          :class="{'item-selected': item.checked, 'item-search':isSearchList}"
          @mouseup="itemClick(item)"
          @dblclick="dbClick(item)"
        >
          <svg
            class="file-icon"
            :class="{'isRoot':!haveSort }"
          >
            <use :xlink:href="getIcon(item)" />
          </svg>
          <div class="file-info">
            <el-tooltip
              class="item"
              effect="dark"
              :content="getName(item)"
              :open-delay="1000"
            >
              <div class="file-name">
                <span v-html="getName(item)" />
              </div>
            </el-tooltip>
            <el-tooltip
              v-if="isSearchList"
              class="item"
              effect="dark"
              :content="getPath(item)"
              :open-delay="1000"
            >
              <div class="file-path">
                <span>{{ getPath(item) }}</span>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div
        v-else
        class="copymove-list-empty"
        :class="{'copymove-list-empty-havesort':haveSort}"
      >
        <span v-if="isSearchList">{{ $t('无符合条件的搜索结果') }}</span>
        <span v-else>{{ $t('文件夹为空') }}</span>
      </div>
    </div>
    <div class="copymove-footer">
      <div
        v-show="!isSearchList"
        class="l-btn lv-80 lv-rm-12 c-btn disb"
        :class="{'c-btn-disabled': !actionCreate}"
        @click="toCreateFolder"
      >
        {{ $t('新建文件夹') }}
      </div>
      <div
        v-show="dc_warn"
        class="warn-txt"
      >
        {{ $t('无法移动/复制到不同数据中心') }}
      </div>
      <div class="copymove-btn">
        <div
          class="l-btn lv-80 lv-rm-12 s-btn disb"
          :disable="!actionCopy"
          :class="{'s-btn-disabled': !actionCopy|| dc_warn}"
          @click="transfer"
        >
          {{ $t('转存') }}
        </div>
      </div>
    </div>
    <!--confirm-->
    <co-confirm
      v-model="showConfirm"
      :title="title"
      :content="content"
      :sure-btn="confirmButton"
      :cancel-btn="cancelButton"
      :only-one="onlyOne"
      :icon-name="confirmIcontype"
      @sure="createFolder"
    >
      <template
        v-if="isCreateFolderDc"
        slot="content"
      >
        <div class="folderName">
          <span class="create-desc">{{ $t('新建文件夹') }}</span>
          <input
            v-model="createData.filename"
            type="text"
            class="filename-input"
            autofocus
            :placeholder="$t('新建文件夹')"
            @focus="nameFocusHandler"
          >
        </div>
        <div class="dcSelect">
          <span class="create-desc">{{ $t('数据中心') }}</span>
          <el-select
            v-model="createData.dcId"
            v-ie-placeholder
            :placeholder="$t('请选择')"
          >
            <el-option
              v-for="(item, index) in dcList"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
      </template>
    </co-confirm>
  </div>
</template>

<script lang="js">

import coConfirm from 'components/common/confirm/index.vue'
import progressBar from 'components/common/progressBar/progress-bar.vue'
import { FILEHANDER } from 'js/mixin/fileType.js'
import * as Util from 'js/util/util.js'
import crumb from './crumb.vue'

const { getData, postData, getDataAbort } = require('js/api/getdata').default

export default {
  mixins:[ FILEHANDER ], // 引用了getFolderType方法
  components: {
    crumb,
    coConfirm,
    progressBar,
  },
  props: {
    data: Object,
    curData: Array,
    selectedData: Array,
    token: '', // 需要输入提取码状态的token
  },
  data() {
    return {
      listData: [],
      currentData: {}, // 移动复制列表当前选中文件夹
      currentListData: {}, // 移动复制当前列表目录的数据
      // 初始默认根目录不可移动，复制，创建文件夹
      actionCopy: false,
      actionCreate: false,
      dc_warn: false,
      fileCanCopy: false,
      fileCanCreate: false,
      // confirm开始
      errorData: {},
      showConfirm: false, // 是否显示confirm，这里通过v-model绑定显示，开始置为false
      content: '',
      subContent: '',
      title: '',
      confirmButton: '',
      cancelButton: '取消',
      onlyOne: false,
      confirmIcontype: '',
      isCreateFolderDc: false,

      // 进度条
      showProgress: false,
      progressData: {},
      clickTimerData: {
        timer: null,
        timeStamp: 200,
      },
      searchTimerData: {
        timer: null,
        timeStamp: 1000,
      },
      isSearchList: false,
      crumbData: [],
      loadingMore: false,
      limit: 20,
      offset: 0,
      searchData: '', // 搜索框内的数据
      isSearchLoading: false, // 是否正在搜索
      isLastSearch: false,
      currentSearchData: {}, // 当前进行搜索的目录信息
      prefix_neid: '', // prefix_neid 同一目录下都是一致的
      prefix_nsid: '',
      lastSearchOffset: 0,
      showCreateFolder: false, // 是否展示新建文件夹input框
      createData: { // 新建文件夹的数据
        filename: this.$t('新建文件夹'),
        dcId: '',
      },
      dcList: [],
      errorMsg: '',
      currentDcType: '', // 当前列表的数据中心
      currentRegionId: null,
    }
  },
  computed: {
    haveSort() {
      return this.crumbData.length > 1
    },
    isAdmin() {
      const { ABILITY_FILE } = Util.ABILITYCODE
      return Util.isCustomAdministrator(ABILITY_FILE)
    },
    searchTitle() {
      return this.isSearchList ? `${this.$t('搜索范围：')}${this.crumbData.slice(1).join('/')}` : ''
    },
    canSort() {
      return !((this.currentListData.path_type == 'share_out' || this.currentListData.path_type == 'share_in') && this.currentListData.path == '/')
    },
    isIE() {
      return Util.isIE()
    }
  },
  watch: {
    crumbData() {
      this.offset = 0
      const cpList = document.querySelector('#copymove-scroll-list')
      if (cpList && cpList.scrollTop) cpList.scrollTop = 0
    },
    searchData(val) {
      clearTimeout(this.searchTimerData.timer)
      if (val) {
        this.searchTimerData.timer = setTimeout(() => {
          this.startSearch()
        }, this.searchTimerData.timeStamp)
      } else if (this.isSearchList) { // 防止搜索列表下 点击进入目录时 进行了两次getListData
        this.offset = 0
        this.currentData = this.currentSearchData
        this.currentSearchData = {}
        this.getListData(this.currentData)
      }
    },
  },
  mounted() {
    this.getOriginData()
    this.init()
  },
  methods: {
    init() {
      // copy=transfer转存就是复制，旧代码用的同一个按钮
      let fileCanCopy = true
      let fileCanCreate = true
      const { selectedData } = this
      for (let i = 0; i < selectedData.length; i++) {
        const { data } = selectedData[i]
        if (data.itransfers_delete) {
          this.fileCanCopy = false
        }
        if (!this.canCopy(data) || !fileCanCopy) {
          fileCanCopy = false
        }
        if (!fileCanCopy) {
          this.fileCanCopy = false
        }
        if (data.access_mode) {
          const status = Util.resolveFileAction(data.access_mode)
          if (status === 'download' && data.is_dir) {
            fileCanCreate = false
          }
        }
      }
      this.fileCanCreate = fileCanCreate
      this.fileCanCopy = fileCanCopy
    },
    getOriginData() {
      if (!Util.isAdmin()) {
        if (this.$store.getters.accountConfig.disable_personal_space === 'true') {
          this.listData = [{
            filename: this.$t('企业空间'), path: '/', path_type: 'ent', icon: 'ent', neid: '企业空间', neid: '1', checked: false,
          }]
        } else {
          this.listData = [{
            filename: this.$t('企业空间'), path: '/', path_type: 'ent', icon: 'ent', neid: '企业空间', neid: '1', checked: false,
          },
          {
            filename: this.$t('个人文件'), path: '/', path_type: 'self', icon: 'self', children: [], neid: '个人文件', checked: false,
          },
          {
            filename: this.$t('我的共享'), path: '/', path_type: 'share_out', icon: 'share_out', neid: '我的共享', checked: false,
          },
          {
            filename: this.$t('收到的共享'), path: '/', path_type: 'share_in', icon: 'share_in', neid: '收到的共享', checked: false,
          }]
        }
      } else {
        this.listData = [{
          filename: this.$t('企业空间'), path: '/', path_type: 'ent', icon: 'ent', children: [], neid: '企业空间', neid: '1', checked: false,
        }]
      }
      this.currentData = {}
      this.currentListData = {}
      this.crumbData = [this.$t('所有目录')]
      this.setOperationStatus()
    },
    getIcon(item) {
      let icontype = ''
      if (item.icon) {
        icontype = `#${item.icon}`
      } else if (item.is_dir) {
        icontype = `#${this.getFolderType(item)}`
      } else {
        icontype = `#${Util.typeIcon(item.mime_type.split('.').pop())}`
      }
      return icontype
    },
    getName(item) {
      if (this.isSearchList) return item.path.split('/').pop() // 避免搜索结果的<mark>标签
      return item.filename ? item.filename : item.path.split('/').pop()
    },
    getPath(item) {
      let pathType = ''
      const path = item.path == '/' ? '' : item.path
      switch (item.path_type) {
        case 'ent':
          pathType = this.$t('企业空间')
          break
        case 'self':
          pathType = this.$t('个人空间')
          break
        case 'share_out':
          pathType = this.$t('我的共享')
          break
        case 'share_in':
          pathType = this.$t('收到的共享')
          break
      }
      return `${pathType}${path}`
    },
    itemClick(item) {
      clearTimeout(this.clickTimerData.timer)
      this.clickTimerData.timer = setTimeout(() => {
        this.$set(item, 'checked', true)
        this.setCurrentSelect(item)
        this.clearOtherSelect()
      }, this.clickTimerData.timeStamp)
    },
    dbClick(item) {
      clearTimeout(this.clickTimerData.timer)
      this.changeCrumbPath(item)
      this.setCurrentSelect(item)
      this.$nextTick(() => {
        this.getListData(item)
      })
    },
    nameFocusHandler() {
      this.errorMsg = ''
    },
    setCurrentSelect(item) {
      this.currentData = item
      this.setOperationStatus(this.currentData)
    },
    clearOtherSelect() {
      this.listData.forEach((element) => {
        if (element.neid != this.currentData.neid) {
          this.$set(element, 'checked', false)
        }
      })
    },
    loadMore(e) {
      const { target } = e
      if ((target.clientHeight + target.scrollTop) >= (target.scrollHeight - 50) && !this.loadingMore && this.offset !== 0) {
        this.loadingMore = true
        if (this.searchData) {
          this.startSearch(true)
          return
        }
        this.getListData(this.currentData, true)
      }
    },
    getListData(item = {}, add) {
      if (!add) this.offset = 0 // 不是下拉加载时，将offset数据置为0
      if (this.listData.length < this.offset * this.limit) {
        return false
      }
      const params = {
        prefix_neid: item.prefix_neid || '',
        orderby: 'mtime',
        neid: /^[0-9]*$/.test(item.neid) ? item.neid : '',
        nsid: item.nsid,
        from: item.from,
        path_type: item.path_type,
        sort: 'desc',
        page_size: this.limit,
        page_num: this.offset,
        include_deleted: false,
        content_type: 'dir',
        waitContent: '.lui-filelist',
        url: item.path,
      }
      getData('getMetadata', params).then((res) => {
        this.prefix_neid = res.data.prefix_neid
        this.prefix_nsid = res.data.nsid
        this.currentListData = res.data
        this.isSearchList = false
        this.searchData = '' // 搜索框中的数据清空
        this.setCurrentSelect(res.data)
        const datas = res.data.content.filter((v) => v.is_dir || v.isDir)
        if (add) {
          this.listData = this.listData.concat(datas)
        } else {
          this.listData = datas
        }
        this.offset += 1
        this.loadingMore = false
      })
    },
    canCopy(param) {
      return true
      // let can = true;
      // if (param.islocked && !param.unlockAdmin) {
      //     // 如果是加锁文件，并且自己不是加锁人，但可以复制
      //     can = true;
      // }
      // if ((param.access_mode & 512) != 512) {
      //     can = false;
      // }
      // return can;
    },
    setOperationStatus(data) {
      const tempData = data
      if (this.crumbData.length === 1) {
        this.actionCopy = false
        this.actionCreate = false
        return
      }
      this.canCopyMove = true
      if (this.isAdmin && tempData.path_type !== 'share_in') {
        tempData.access_mode = 4095
        tempData.realpath = '/'
      }
      if (tempData.path === '/') {
        if (tempData.path_type === 'self'
          || (this.isAdmin && tempData.path_type === 'ent')) {
          this.actionCopy = true
          this.actionCreate = true
        } else {
          this.actionCopy = false
          this.actionCreate = false
        }
      } else {
        if ((tempData.access_mode & 1026) === 1026) {
          this.actionCopy = true // 可复制
        } else {
          this.actionCopy = false
        }
        if ((tempData.access_mode & 1056) === 1056) {
          this.actionCreate = true // 可新建
        } else {
          this.actionCreate = false
        }
      }
      this.$nextTick(() => {
        if (!this.fileCanCopy) {
          this.actionCopy = false
        }
        if (!this.fileCanCreate) {
          this.actionCreate = false
        }
      })
      this.dc_warn = !this.canCopyMove
    },
    // 检查将要移动至的目录是不是与所移动的文件/文件夹 同一目录
    checkSameRoot() {
      const { selectedData } = this
      for (let i = 0; i < selectedData.length; i++) {
        const tmp = selectedData[i].data
        if (tmp) {
          let path = tmp.path.split('/')
          path.pop()
          path = path.join('/')
          path || (path = '/')
          if (path == this.currentData.path && tmp.path_type == this.currentData.path_type) {
            return true
          }
        }
      }
      return false
    },
    changeProgressStatus(progress) {
      const titleNode = document.querySelector('.copymove-box').parentNode.parentNode
      let childNode
      if (titleNode.children) {
        childNode = titleNode.children[0]
      } else {
        childNode = titleNode.childNodes[0]
      }
      this.showProgress = !this.showProgress
      if (progress === 100) {
        this.$emit('closeDialog')
        const toData = this.formatData(this.currentData)
        this.$toast.simpleShow(
          this.$t('已成功保存文件'),
          'success',
          3000,
          this.$t('点击查看'),
          () => {
            window.location.href = `/v/list/${toData.path_type}/${toData.neid}`
          },
        )
        this.refreshList()
      }
    },
    action() {
      if (this.errorData.sameFile || this.errorData.showTips) {
        return
      }
      // 有锁定文件弹窗
      if (this.errorData.lockFile) {
        const { selectedData } = this
        const neids = []
        if (selectedData.length > 1) {
          for (let i = 0; i < selectedData.length; i++) {
            neids.push(selectedData[i].data.neid)
          }
        } else {
          neids.push(selectedData[0].data.neid)
        }
        this.$emit('setCmd', { name: 'lockFileList', operateType: '1' }, { neids: neids.toString() })
      }
      this.transfer()
      this.copyMove(this.errorData.type, this.errorData.rename, this.errorData.share)
      this.errorData = {}
    },
    closeConfirm() {
      this.errorData = {}
      this.showConfirm = false
    },
    // 从移动复制挪过来的方法，因为转存的提示都是toast，所以这个方法暂时没有用
    errorAction(error, type) {
      const err = error.response.data
      this.content = err.message
      this.errorData.type = type
      this.confirmIcontype = ''
      this.cancelButton = ''
      this.title = this.$t('提示')
      this.confirmButton = this.$t('确定')
      this.onlyOne = true
      if (err.state == 409) {
        if (type === 'move' && this.checkSameRoot()) {
          this.content = this.$t('目标与源文件夹相同，请选择其他文件夹')
          this.errorData.sameFile = true
          this.confirmIcontype = '#warn'
        } else {
          this.onlyOne = false
          this.confirmButton = this.$t('重命名')
          this.cancelButton = this.$t('取消操作')
          this.errorData.rename = true
        }
      } else if (err.state == 412) { // 要移动的文件夹已共享或者授权
        this.onlyOne = false
        this.title = this.$t('确认')
        this.confirmButton = this.$t('继续')
        this.cancelButton = this.$t('取消')
        this.errorData.share = true
      } else if (err.state == 403) {
        this.errorData.sameFile = true
        this.confirmIcontype = '#warn'
      } else if (err.state == 405) {
        this.errorData.sameFile = true
        this.confirmIcontype = '#warn'
      } else {
        this.errorData.showTips = true
      }
      this.showConfirm = true
    },
    formatData(meta, isDeliveryMeta) {
      // root: "databox"
      // path: "/zjatsl"
      // path_type: "self"
      // from: ""
      // neid: 1612640133
      // root: "databox"
      // path: "/周     报/新建文件夹111111111111111111111111111111"
      // delivery_code: "a2d0f1bbf6cd4097a3b77a3fcb4b4e4b"
      // rev: ""
      // neid: 1776986052
      if (isDeliveryMeta) {
        const {
          root = 'databox', path, delivery_code, rev, neid, nsid, prefix_neid,
        } = meta
        return {
          root,
          path,
          delivery_code,
          rev,
          neid,
          nsid,
          prefix_neid,
          delivery_creator_uid: this.$store.state.curFileInfo.delivery_creator_uid,
        }
      }
      const {
        root = 'databox', path, path_type, from, neid, prefix_neid,
      } = meta
      return {
        root, path, path_type, from, neid, prefix_neid,
      }
    },
    transfer() {
      if (!this.actionCopy || this.dc_warn) return
      const toData = this.formatData(this.currentData)
      const fromData = this.selectedData.map((v, i) => this.formatData(v.data, true))
      const data = {
        json: JSON.stringify({
          from: fromData,
          to: toData,
          other_data: { delivery_id: this.data.deliverycode },
        }),
      }
      // 添加token验证
      if (this.token != '') { data.token = this.token }
      const options = {
        url: `/${this.data.deliverycode}`,
      }
      postData('deliveryTransfer', data).then((res) => {
        this.$emit('transferFinished', res)
        if (res.status == 200) {
          // 判断是否需要进度条
          if (res.data.task_type === 2) {
            this.progressData.task_id = res.data.task_id
            this.progressData.mainTxt = this.$t('正在转存文件，请稍后...')
            this.changeProgressStatus()
          } else {
            this.$emit('closeDialog')
            this.$toast.simpleShow(
              this.$t('已成功保存文件'),
              'success',
              3000,
              this.$t('点击查看'),
              () => {
                window.location.href = `/v/list/${toData.path_type}/${toData.neid}`
              },
            )
            this.refreshList()
          }
          // 这个刷新接口有问题或者哪里有问题，需要后端帮忙看一下
        }
      }).catch((error) => {
        // 原来的代码里边都是toast
        const res = error.response
        if (res) {
          if (res.data && res.data.code === 'account space limit') {
            this.$toast.simpleShow(this.$t('选择的目录空间不足，保存失败'), 'warn')
            return
          }
          this.$toast.simpleShow(res.data.message, 'warn')
        }
        /**
                if (ret.code == 200) {
                    Tips.show(ret.message);
                } else if (ret.code == 500) {
                    Tips.warn(ret.message.join("<br>"));
                } else {
                    Tips.warn(ret.message);
                }
                 */
        // this.errorAction(error, 'transfer')
      })
    },
    showDcCreate() {
      this.title = this.$t('新建文件夹')
      this.confirmButton = this.$t('确定')
      this.cancelButton = this.$t('取消')
      this.isCreateFolderDc = true
      this.showConfirm = true
    },
    toCreateFolder() {
      if (!this.actionCreate) return
      this.showCreateFolder = true // 不需要选择数据中心，直接在列表中显示新建的input
      this.$nextTick(() => {
        this.$refs.createFile.focus()
        this.$refs.createFile.setSelectionRange(0, this.createData.filename.length)
      })
    },
    getDcList() {
      getData('getDcList', { accountId: this.$store.state.lenovoData.userInfo.account_id }).then((res) => {
        const dcInfo = res.data
        this.createData.dcId = dcInfo[0].id
        for (let i = 0; i < dcInfo.length; i++) {
          const data = {
            value: dcInfo[i].id,
            label: dcInfo[i].alias,
          }
          this.dcList.push(data)
        }
      })
    },
    createFolder() {
      const info = this.currentListData
      const data = { // 用于新建的data
        is_update: false,
        path_type: info.path_type,
        from: info.from || '',
        prefix_neid: info.prefix_neid || '',
      }
      const param = {
        url: `${info.path}/${this.createData.filename}`,
      }
      postData('createFolder', data, param).then((res) => {
        if (res.status == 200) {
          this.defaultCreateData() // 重置createData数据
          this.showCreateFolder = false // 隐藏新建文件夹input框
          const params = {
            neid: res.data.neid,
            path: res.data.path,
            path_type: res.data.path_type,
          }
          // let fileName = res.data.path.slice(res.data.path.lastIndexOf('/') + 1,res.data.path.length)
          this.$toast.simpleShow(this.$t('成功创建文件夹'), 'success')
          getData('getMetadata', params).then((ret) => {
            this.listData.unshift(ret.data)
          }).catch((error) => {
            console.log(error)
          })
        }
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.$toast.simpleShow(error.response.data.message, 'error')
        }
      })
    },
    cancelCreate() {
      this.showCreateFolder = false
    },
    defaultCreateData() { // 重置新建文件夹的数据
      this.createData = {
        filename: this.$t('新建文件夹'),
        dcId: '',
      }
    },
    refreshList() {
      this.$emit('refreshList')
    },
    changeCrumbPath(param, isCrumbJump) {
      this.isSearchList = false
      if (isCrumbJump) {
        this.crumbData = param.path.split('/')
      } else {
        const path = this.getPath(param)
        this.crumbData = (`${this.$t('所有目录')}/${path}`).split('/')
      }
    },
    crumbJump(param) {
      this.changeCrumbPath(param, true)
      this.$nextTick(() => {
        if (param.index === 0) { // 跳转至所有目录
          this.getOriginData()
        } else {
          const data = {
            path_type: this.currentData.path_type, // 和跳转前选中目录的path_type是一致的 所以直接取
            path: `/${param.path.split('/').slice(2).join('/')}`, // path截取
            neid: '',
            prefix_neid: this.prefix_neid || '',
          }
          this.getListData(data)
        }
      })
    },
    async startSearch(isAdd) {
      const meta = this.currentListData || {}
      // 新增type: folder只查找文件夹
      console.log(this.currentListData)
      const params = {
        query: this.searchData,
        path: meta.path,
        path_type: meta.path_type,
        type: 'folder',
        limit: 20,
        prefix_neid: meta.neid,
        prefix_nsid: this.prefix_nsid,
        is_full_box: false,
        next_index: this.lastSearchOffset,
        S: this.$store.state.S,
      }
      if (isAdd) {
        if (this.lastSearchOffset && !this.isLastSearch) {
          params.offset = this.lastSearchOffset
        }
      } else {
        this.lastSearchOffset = 0
        this.isLastSearch = false
      }
      if (this.isLastSearch) {
        return
      }
      this.isSearchLoading = true
      const result = await this.fetchSearch(params)
      if (isAdd) {
        if (result) {
          this.listData = this.listData.concat(result.entrys.filter((v) => v.is_dir || v.isDir))
        }
      } else if (result) {
        this.listData = result.entrys.filter((v) => v.is_dir || v.isDir)
      }
      // this.searching = true
      this.timeHandler = null
      this.isSearchList = true
      this.currentSearchData = this.currentData // 记录一下在哪个目录下进行的搜索
    },
    fetchSearch(params) {
      const { source, action } = getDataAbort('usualSearch', params)
      window.cancel = source.cancel
      // store.commit('SET_SEARCH_CANCEL', source.cancel)
      return action.then((res) => {
        this.isSearchLoading = false
        this.loadingMore = false
        if (!res.data.has_more) {
          this.isLastSearch = true
        }
        this.lastSearchOffset = res.data.next_index
        // store.commit('SET_SEARCH_CANCEL')
        return res.data
      }, (err) => {
        console.error('search error:', err)
      })
    },
    clearAll() {
      this.searchData = '' // 会通过对searchData的watch回到之前的列表
    },
  },
}
</script>

<style lang="less">
.copymove-box{
  margin: 0 24px 24px;
  width: 472px;
  .copymove-search{
    input{
      height:32px;
      border-color: #E8EBEF;
      line-height: normal;
      &.el-input__inner:focus,&.el-input__inner:hover{
        border-color: #E8EBEF;
      }
    }
    .search-clear{
      display: inline-block;
      margin: 8px 8px 0 0;
      .icon-loading {
        display: inline-block;
        background-color: #fff;
        height: 20px;
        line-height: 20px;
        width: 20px;
        margin-right: 8px;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  .crumb-title{
    padding-bottom: 8px;
    span{
      font-size: 14px;
      color: #1B2733;
    }
  }
  .copymove-content{
    border: 1px solid #E8EBEF;
    &.content-havesort{
      border-top: none;
    }
    .copymove-crumb{
      padding-left: 16px;
      background: #F6F7FA;
      height: 24px;
      line-height: 24px;
    }
    .copymove-list{
      overflow-y: auto;
      overflow-x: hidden;
      height: 360px;
      margin-top: 8px;
      &.copymove-list-havesort{
        height: 326px;
      }
      &::-webkit-scrollbar {
        width: 6px;
        height: 4px;
      }
      &::-webkit-scrollbar-thumb {
        margin-left: 20px;
        background: #C1C7CD;
        border-radius: 3px;
      }
      .new-folder{
        height: 36px;
        line-height: 36px;
        position: relative;
        .file-icon {
          display: inline-block;
          height: 20px;
          vertical-align: middle;
          width: 20px;
          padding: 0 6px 0 16px;
        }
        input {
          border: 1px solid #ddd;
          border-radius: 3px;
          text-indent: 4px;
          width: 340px;
          height: 25px;
          line-height: normal;
          font-size: 14px;
          padding-right: 60px;
        }
        .wrap-btns{
          position: absolute;
          right: 23px;
          top: 8px;
          .cancel{
            position: relative;
            width: 20px;
            height: 20px;
            display: inline-block;
            float: right;
            margin-right: 8px;
            .icon-cancel{
              position: absolute;
              top: 4px;
              left: 4px;
              width: 12px;
              height: 12px;
              padding: 0;
            }
          }
          .cancel:hover{
            background: #F6F7FA;
          }
          .sure{
            position: relative;
            width: 20px;
            height: 20px;
            display: inline-block;
            float: right;
            margin-right: 8px;
            .icon-sure{
              position: absolute;
              top: 5px;
              left: 3px;
              width: 14px;
              height: 10px;
              padding: 0;
            }
          }
          .sure:hover{
            background: #F6F7FA;
          }
          /*.icon{*/
            /*width: 14px;*/
            /*height: 14px;*/
            /*padding: 4px;*/
            /*&:hover{*/
              /*background: #e8ebef;*/
            /*}*/
          /*}*/
        }
      }
      .list-item{
        height: 36px;
        display: flex;
        align-items: center;
        position: relative;
        cursor: pointer;
        &:hover{
          background-color: #F6F7FA;
        }
        &.item-selected{
          background-color: #F6F7FA;
        }
        &.item-search{
          height: 56px;
        }
        .file-icon{
          float: left;
          width: 20px;
          height: 20px;
          margin-left: 16px;
          position: absolute;
          top: 8px;
          &.isRoot{
            margin-top: 2px;
          }
        }
        .file-info{
          margin-left: 45px;
          overflow: hidden;
          div{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: fit-content;
            // display: inline-block;
            max-width: 100%;
          }
          span{
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .file-name{
            height: 36px;
            line-height: 36px;
            span{
              font-size: 14px;
              color: #1B2733;
            }
          }
          .file-path{
            height: 16px;
            line-height: 16px;
            span{
              font-size: 12px;
              color: #637282;
            }
          }
        }
      }
    }
    .copymove-list-empty{
      height: 368px;
      line-height: 360px;
      text-align: center;
      &.copymove-list-empty-havesort{
        height: 334px;
        line-height: 326px;
      }
      span{
        font-size:14px;
        color: #637282;
      }
    }
  }
  .copymove-footer{
    margin-top: 24px;
    .warn-txt{
      display: inline;
      font-size: 12px;
      color: red;
      margin-left:8px;
    }
    .copymove-btn{
      float: right;
      margin-bottom: 24px;
      button{
        line-height:30px;
      }
      .copy-btn{
        margin-left: 8px;
      }
    }
  }
  // ie样式兼容
  &.is-ie{
    .file-icon{
      margin-top: -12px;
      &.isRoot{
        margin-top: -8px!important; //根目录下 icon小 兼容
      }
    }
  }
  .create-desc {
    font-size: 14px;
    line-height: 38px;
  }
  .filename-input {
    width: 287px;
    height: 38px;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    outline: 0;
    padding: 0 15px;
    float: right;
    &:focus {
      border: 1px solid #66afe9;
    }
  }
  .dcSelect {
    margin-top: 20px;
  }
  .el-select {
    width: 287px;
    float: right;
  }
  .el-select .el-input.is-focus .el-input__inner, .el-select .el-input__inner:focus {
    border-color: #0a64fa;
  }
  .el-select-dropdown .el-select-dropdown__item.selected, .el-select-dropdown__item.selected span {
    color: #0a64fa;
    font-weight: 400;
  }
}

</style>
